import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './close_toaster_button.module.scss';
import { MaterialIcon } from '../../material-icon/MaterialIcon';

export const CloseToasterButton: FC<{
  closeToast?: () => void;
  color?: string;
}> = ({ closeToast = () => {}, color = 'white' }) => (
  <button
    type="button"
    className={classNames(
      styles.close,
      { [styles.white]: color === 'white' },
      { [styles.black]: color === 'black' },
    )}
    onClick={closeToast}
  >
    <MaterialIcon name="close" className={styles.icon} />
  </button>
);
